/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { useThree } from '@react-three/fiber';

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';
import { controls } from '../../../../../../../../redux/reducers/common/eventReducer';

import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { delModel, extrudeSettings, roofPattern, textureAnisotropy } from '../../../../../../../../utils/Functions';
import useMouseEvents from '../../../../../../../../hooks/useMouseEvents';
import { MaterialInnerWall, MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../../../CustomMaterial';

const WallModel = () => {
    const { gl } = useThree ();

    const wallThickness = 0.005;
    const cbFrontBackWallOffset = 0.155;
    // const offsetWithDoorThickness = 0.127;

    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement != undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false
    
    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined])

    const frontOffset = useMemo(() => {
        if (params.leftLeanStoragePosition === params.lean_p_d - parseInt(params.add_storage)) {
            return -0.1;
        } else if (params.leftLeanStoragePosition === 0) {
            return 0.1;
        } else {
            return 0;
        }
    }, [params.lean_p_d, legDistance, params.leftLeanStoragePosition, params.add_storage]);

    const backOffset = useMemo(() => {
        if (params.leftLeanStoragePosition === 0) {
            return 0.1;
        } else {
            return 0;
        }
    }, [params.leftLeanStoragePosition]);
    
    const sidewallOffset = 0.14;

     

    const GableStorageFrontWallModelObj = useMemo(() => {
        let regularHeight;
        if(params.p_r_s === 1) regularHeight = const_var.roofRegularDst * 2;
        else regularHeight = 0

        let innerModel;
        let outerModel;
        let wainscotModel;

        // inner wall model
        const innerWallModel  = new THREE.Shape();
        if(params.p_r_s === 1){
            innerWallModel.moveTo(-(params.lean_p_w / 2 - 0.05), params.lean_p_h);
            innerWallModel.lineTo(-(params.lean_p_w / 2 - 0.05) + 0.01, params.lean_p_h + const_var.roofRegularDst);
            innerWallModel.quadraticCurveTo(
                -(params.lean_p_w / 2 - 0.05) + 0.02, params.lean_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_p / 12) / 10,
                -(params.lean_p_w / 2 - 0.05) + 0.01 + const_var.roofRegularDst, params.lean_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_p / 12
            );
            innerWallModel.lineTo(0, params.lean_p_h + ((params.b_l_t_r_p / 12) * (params.lean_p_w/2)) + const_var.roofRegularDst * 2 - 0.03);
    
            innerWallModel.lineTo((params.lean_p_w / 2 - 0.05) - 0.01 - const_var.roofRegularDst, params.lean_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_p / 12);
            innerWallModel.quadraticCurveTo(
                (params.lean_p_w / 2 - 0.05) - 0.01, params.lean_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_p / 12) / 10,
                (params.lean_p_w / 2 - 0.05) - 0.01, params.lean_p_h + const_var.roofRegularDst
            );
            innerWallModel.lineTo((params.lean_p_w / 2 - 0.05) - 0.01, params.lean_p_h);
            innerWallModel.lineTo((params.lean_p_w / 2 - 0.05) + 0.005, 0);
            innerWallModel.lineTo(-(params.lean_p_w / 2 - 0.05) + 0.005, 0);
            innerWallModel.closePath();
        } else{
            innerWallModel.moveTo(-(params.lean_p_w / 2 - 0.05 + cbFrontBackWallOffset), 0);
            innerWallModel.lineTo(-(params.lean_p_w / 2 - 0.05 + cbFrontBackWallOffset), params.lean_p_h + (params.p_r_s !== 1 && -0.02) + regularHeight);
            innerWallModel.lineTo(0, params.lean_p_h + (params.b_l_t_r_p / 12) * (params.lean_p_w / 2 + 0.1) + regularHeight);
            innerWallModel.lineTo((params.lean_p_w / 2 - 0.05 + cbFrontBackWallOffset), params.lean_p_h + (params.p_r_s !== 1 && -0.02) + regularHeight);
            innerWallModel.lineTo((params.lean_p_w / 2 - 0.05 + cbFrontBackWallOffset), 0);
            innerWallModel.closePath();
        }

        const meshInnerWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallModel, extrudeSettings(0.005)));
        const meshDoorDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableLeftLeanStorageFront', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshDoorDelModelLeft = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableLeftLeanLeft', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshDoorDelModelRight = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableLeftLeanRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
    
        let meshInnerWallModel_Temp = meshInnerWallModel.clone();
        meshInnerWallModel_Temp.rotateY(Math.PI / 2);
        meshInnerWallModel_Temp.position.set(-params.p_w / 2 - parseInt(params.add_storage) - 0.15 - frontOffset + 0.05, 0, 0);
        meshInnerWallModel_Temp.updateMatrixWorld();
    
        let meshDoorDelModel_Temp = meshDoorDelModel.clone();
        meshDoorDelModel_Temp.rotateY(Math.PI / 2)
        meshDoorDelModel_Temp.position.set(-params.p_w / 2 - parseInt(params.add_storage) - 0.5 - frontOffset, 0, -params.lean_p_pos);
        meshDoorDelModel_Temp.updateMatrixWorld();

        let meshDoorDelModelLeft_Temp = meshDoorDelModelLeft.clone();
        meshDoorDelModelLeft_Temp.position.set( params.leftLeanStoragePosition, 0, -params.lean_p_w / 2 - 0.9)
        meshDoorDelModelLeft_Temp.updateMatrixWorld();
    
        let meshDoorDelModelRight_Temp = meshDoorDelModelRight.clone();
        meshDoorDelModelRight_Temp.position.set(params.leftLeanStoragePosition, 0, params.lean_p_w / 2 - 0.1)
        meshDoorDelModelRight_Temp.updateMatrixWorld();
    
        const meshInnerWallModel_CSG = CSG.fromMesh(meshInnerWallModel_Temp);
        const meshDoorDelModel_CSG = CSG.fromMesh(meshDoorDelModel_Temp);
        const meshDoorDelModelLeft_CSG = CSG.fromMesh(meshDoorDelModelLeft_Temp);
        const meshDoorDelModelRight_CSG = CSG.fromMesh(meshDoorDelModelRight_Temp);
    
        const innerWallModel_CSG = meshInnerWallModel_CSG.subtract(meshDoorDelModel_CSG);
        const innerWallModel_CSG_temp1 = innerWallModel_CSG.subtract(meshDoorDelModelLeft_CSG);
        const innerWallModel_CSG_temp2 = innerWallModel_CSG_temp1.subtract(meshDoorDelModelRight_CSG);
        const CSGInnerWallModel = CSG.toMesh(
            innerWallModel_CSG_temp2,
            new THREE.Matrix4()
        )

        innerModel = CSGInnerWallModel.geometry;
    
        // outer wall model
        const horizontalDepth = params.lean_p_w + cbFrontBackWallOffset * 2
        const HSPosition = params.lean_p_w / -2 - cbFrontBackWallOffset
    
        const verticalHorizontalPosS = 
            {
                "x": params.p_w / -2 - 0.205 - parseInt(params.add_storage),
                "y": (params.p_w_c_n ? 2.935 : 0),
                "z": HSPosition
            }
        const verticalHorizontalRotS = 
            {
                "x": 0,
                "y": 0,
                "z": Math.PI / 2
            }
        const patternLengthS = params.lean_p_h + params.b_l_t_r_p / 12 * params.lean_p_w / 2 + regularHeight + (params.p_w_c_n ? -2.935 : 0)
        const patternDepthS = horizontalDepth
        
        const meshOuterWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthS, isPattern), extrudeSettings(patternDepthS)));
        const meshOuterWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallModel, extrudeSettings(1)))
        
        let meshOuterWallModel_Temp = meshOuterWallModel.clone();
        meshOuterWallModel_Temp.position.set(verticalHorizontalPosS.x - frontOffset, verticalHorizontalPosS.y, verticalHorizontalPosS.z);
        meshOuterWallModel_Temp.rotation.set(verticalHorizontalRotS.x,verticalHorizontalRotS.y,verticalHorizontalRotS.z);
        meshOuterWallModel_Temp.updateMatrixWorld();
    
        let meshOuterWallDelModel_Temp = meshOuterWallDelModel.clone();
        meshOuterWallDelModel_Temp.position.set(-params.p_w / 2 - parseInt(params.add_storage) + 0.5 - frontOffset, 0, 0);
        meshOuterWallDelModel_Temp.rotation.set(0,Math.PI / -2,0)
        meshOuterWallDelModel_Temp.updateMatrixWorld();
    
        const meshOuterWallModel_CSG = CSG.fromMesh(meshOuterWallModel_Temp);
        const meshOuterWallDelModel_CSG = CSG.fromMesh(meshOuterWallDelModel_Temp);
    
        const outerWallModel_CSG = meshOuterWallModel_CSG.subtract(meshDoorDelModel_CSG);
        const meshOuterWallDel_CSG = outerWallModel_CSG.intersect(meshOuterWallDelModel_CSG);
        const outerWallModel_CSG_temp1 = meshOuterWallDel_CSG.subtract(meshDoorDelModelLeft_CSG);
        const outerWallModel_CSG_temp2 = outerWallModel_CSG_temp1.subtract(meshDoorDelModelRight_CSG)
        const CSGOuterWallModel = CSG.toMesh(outerWallModel_CSG_temp2,new THREE.Matrix4());

        outerModel = CSGOuterWallModel.geometry;

        // wainscot wall model
        const wainscotVerticalHorizontalPosS =
            {
                "x": params.p_w / -2 - parseInt(params.add_storage) - 0.205,
                "y" : 0,
                "z" : HSPosition
            }
        const wainscotVerticalHorizontalRotS = 
            {
                "x": 0,
                "y": 0,
                "z": Math.PI / 2
            }
        const lengthPatternS = 3
        const depthPatternS = patternDepthS

        const meshWainscotWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternS, isPattern), extrudeSettings(depthPatternS)))
        let meshWainscotWallModel_Temp = meshWainscotWallModel.clone();
        meshWainscotWallModel_Temp.position.set(wainscotVerticalHorizontalPosS.x - frontOffset,wainscotVerticalHorizontalPosS.y,wainscotVerticalHorizontalPosS.z);
        meshWainscotWallModel_Temp.rotation.set(wainscotVerticalHorizontalRotS.x,wainscotVerticalHorizontalRotS.y,wainscotVerticalHorizontalRotS.z);
        meshWainscotWallModel_Temp.updateMatrixWorld();

        const meshWainscotWallModel_CSG = CSG.fromMesh(meshWainscotWallModel_Temp);

        const WainscotWallModel_CSG = meshWainscotWallModel_CSG.subtract(meshDoorDelModel_CSG);
        const WainscotWallModelCSG = WainscotWallModel_CSG.intersect(meshOuterWallDelModel_CSG);
        const WainscotWallModel_CSG_temp1 = WainscotWallModelCSG.subtract(meshDoorDelModelLeft_CSG);
        const WainscotWallModel_CSG_temp2 = WainscotWallModel_CSG_temp1.subtract(meshDoorDelModelRight_CSG);
        const CSGWainscotWallModel = CSG.toMesh(
            WainscotWallModel_CSG_temp2,
            new THREE.Matrix4()
        )

        wainscotModel = CSGWainscotWallModel.geometry;

        return {innerModel, outerModel, wainscotModel}

    }, [params.wallTexture,params.lean_p_pos, params.add_storage, params.p_v_w, params.p_w, params.b_l_t_r_p, params.lean_p_w, params.p_r_s, params.lean_p_d, params.lean_p_h, params.add_storage_check, params.add_storage, const_var.newDoorsArray,params.p_b_c_b_l_f, params.p_w_c_n, frontOffset, isPattern, params.leftLeanStoragePosition]);

    const GableStorageBackWallModelObj = useMemo(() => {
        let regularHeight;
        if(params.p_r_s === 1) regularHeight = const_var.roofRegularDst * 2;
        else regularHeight = 0

        let innerModel;
        let outerModel;
        let wainscotModel;

        // inner wall model
        const innerWallModel = new THREE.Shape();
        if(params.p_r_s === 1){
            innerWallModel.moveTo(-(params.lean_p_w - 0.05) / 2, params.lean_p_h);
            innerWallModel.lineTo(-(params.lean_p_w - 0.05) / 2 + 0.01, params.lean_p_h + const_var.roofRegularDst);
            innerWallModel.quadraticCurveTo(
                -(params.lean_p_w - 0.05) / 2 + 0.02, params.lean_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_p / 12) / 10,
                -(params.lean_p_w - 0.05) / 2 + 0.01 + const_var.roofRegularDst, params.lean_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_p / 12
            );
            innerWallModel.lineTo(0, params.lean_p_h + ((params.b_l_t_r_p / 12) * (params.lean_p_w/2)) + const_var.roofRegularDst * 2 - 0.03);
    
            innerWallModel.lineTo((params.lean_p_w / 2 - 0.05) - 0.01 - const_var.roofRegularDst, params.lean_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_p / 12);
            innerWallModel.quadraticCurveTo(
                (params.lean_p_w / 2 - 0.05) - 0.01, params.lean_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_p / 12) / 10,
                (params.lean_p_w / 2 - 0.05) - 0.01, params.lean_p_h + const_var.roofRegularDst
            );
            innerWallModel.lineTo((params.lean_p_w / 2 - 0.05) - 0.01, params.lean_p_h);
            innerWallModel.lineTo((params.lean_p_w / 2 - 0.05) + 0.005, 0);
            innerWallModel.lineTo(-(params.lean_p_w / 2 - 0.05) + 0.005, 0);
            innerWallModel.closePath();
        } else{
            innerWallModel.moveTo(-(params.lean_p_w / 2 - 0.05 + cbFrontBackWallOffset), 0);
            innerWallModel.lineTo(-(params.lean_p_w / 2 - 0.05 + cbFrontBackWallOffset), params.lean_p_h + (params.p_r_s !== 1 && -0.02) + regularHeight);
            innerWallModel.lineTo(0, params.lean_p_h + (params.b_l_t_r_p / 12) * (params.lean_p_w / 2 + 0.1) + regularHeight);
            innerWallModel.lineTo((params.lean_p_w / 2 - 0.05 + cbFrontBackWallOffset), params.lean_p_h + (params.p_r_s !== 1 && -0.02) + regularHeight);
            innerWallModel.lineTo((params.lean_p_w / 2 - 0.05 + cbFrontBackWallOffset), 0);
            innerWallModel.closePath();
        }

        const meshInnerWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallModel, extrudeSettings(0.005)));
        const meshDoorDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableLeftLeanStorageBack', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshDoorDelModelLeft = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableLeftLeanLeft', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshDoorDelModelRight = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableLeftLeanRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
    
        let meshInnerWallModel_Temp = meshInnerWallModel.clone();
        meshInnerWallModel_Temp.rotateY(Math.PI / 2);
        meshInnerWallModel_Temp.position.set(-params.p_w / 2 + 0.12 - 0.05, 0, 0);
        meshInnerWallModel_Temp.updateMatrixWorld();
    
        let meshDoorDelModel_Temp = meshDoorDelModel.clone();
        meshDoorDelModel_Temp.rotateY(Math.PI / 2)
        meshDoorDelModel_Temp.position.set(-params.p_w / 2 -0.5, 0, -params.lean_p_pos);
        meshDoorDelModel_Temp.updateMatrixWorld();

        let meshDoorDelModelLeft_Temp = meshDoorDelModelLeft.clone();
        meshDoorDelModelLeft_Temp.position.set( params.leftLeanStoragePosition, 0, -params.lean_p_w / 2 - 0.9)
        meshDoorDelModelLeft_Temp.updateMatrixWorld();
    
        let meshDoorDelModelRight_Temp = meshDoorDelModelRight.clone();
        meshDoorDelModelRight_Temp.position.set(params.leftLeanStoragePosition, 0, params.lean_p_w / 2 - 0.1)
        meshDoorDelModelRight_Temp.updateMatrixWorld();
    
        const meshInnerWallModel_CSG = CSG.fromMesh(meshInnerWallModel_Temp);
        const meshDoorDelModel_CSG = CSG.fromMesh(meshDoorDelModel_Temp);
        const meshDoorDelModelLeft_CSG = CSG.fromMesh(meshDoorDelModelLeft_Temp);
        const meshDoorDelModelRight_CSG = CSG.fromMesh(meshDoorDelModelRight_Temp);
    
        const innerWallModel_CSG = meshInnerWallModel_CSG.subtract(meshDoorDelModel_CSG);
        const innerWallModel_CSG_temp1 = innerWallModel_CSG.subtract(meshDoorDelModelLeft_CSG);
        const innerWallModel_CSG_temp2 = innerWallModel_CSG_temp1.subtract(meshDoorDelModelRight_CSG);
        const CSGInnerWallModel = CSG.toMesh(
            innerWallModel_CSG_temp2,
            new THREE.Matrix4()
        )

        innerModel = CSGInnerWallModel.geometry;
    
        // outer wall model
        const horizontalDepth = params.lean_p_w + cbFrontBackWallOffset * 2
        const HSPosition = params.lean_p_w / 2 + cbFrontBackWallOffset
    
        const verticalHorizontalPosS = 
            {
                "x": params.p_w / -2 + 0.205,
                "y": (params.p_w_c_n ? 2.935 : 0),
                "z": HSPosition
            }
        const verticalHorizontalRotS = 
            {
                "x": 0,
                "y": Math.PI,
                "z": Math.PI / 2
            }
        const patternLengthS = params.lean_p_h + params.b_l_t_r_p / 12 * params.lean_p_w / 2 + regularHeight + (params.p_w_c_n ? -2.935 : 0)
        const patternDepthS = horizontalDepth
        
        const meshOuterWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthS, isPattern), extrudeSettings(patternDepthS)));
        const meshOuterWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallModel, extrudeSettings(1)))
        
        let meshOuterWallModel_Temp = meshOuterWallModel.clone();
        meshOuterWallModel_Temp.position.set(verticalHorizontalPosS.x,verticalHorizontalPosS.y,verticalHorizontalPosS.z);
        meshOuterWallModel_Temp.rotation.set(verticalHorizontalRotS.x,verticalHorizontalRotS.y,verticalHorizontalRotS.z);
        meshOuterWallModel_Temp.updateMatrixWorld();
    
        let meshOuterWallDelModel_Temp = meshOuterWallDelModel.clone();
        meshOuterWallDelModel_Temp.position.set(-params.p_w / 2 + 0.5, 0, 0);
        meshOuterWallDelModel_Temp.rotation.set(0,Math.PI / -2,0)
        meshOuterWallDelModel_Temp.updateMatrixWorld();
    
        const meshOuterWallModel_CSG = CSG.fromMesh(meshOuterWallModel_Temp);
        const meshOuterWallDelModel_CSG = CSG.fromMesh(meshOuterWallDelModel_Temp);
    
        const outerWallModel_CSG = meshOuterWallModel_CSG.subtract(meshDoorDelModel_CSG);
        const meshOuterWallDel_CSG = outerWallModel_CSG.intersect(meshOuterWallDelModel_CSG);
        const meshOuterWallDel_CSG_temp1 = meshOuterWallDel_CSG.subtract(meshDoorDelModelLeft_CSG);
        const meshOuterWallDel_CSG_temp2 = meshOuterWallDel_CSG_temp1.subtract(meshDoorDelModelRight_CSG)
        const CSGOuterWallModel = CSG.toMesh(meshOuterWallDel_CSG_temp2,new THREE.Matrix4());

        outerModel = CSGOuterWallModel.geometry;

        // wainscot wall model
        const wainscotVerticalHorizontalPosS = 
            {
                "x": params.p_w / -2 + 0.205,
                "y" : 0,
                "z" : HSPosition
            }
        const wainscotVerticalHorizontalRotS =
            {
                "x": 0,
                "y": Math.PI,
                "z": Math.PI / 2
            }
        const lengthPatternS = 3
        const depthPatternS = patternDepthS

        const meshWainscotWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternS, isPattern), extrudeSettings(depthPatternS)))
        let meshWainscotWallModel_Temp = meshWainscotWallModel.clone();
        meshWainscotWallModel_Temp.position.set(wainscotVerticalHorizontalPosS.x,wainscotVerticalHorizontalPosS.y,wainscotVerticalHorizontalPosS.z);
        meshWainscotWallModel_Temp.rotation.set(wainscotVerticalHorizontalRotS.x,wainscotVerticalHorizontalRotS.y,wainscotVerticalHorizontalRotS.z);
        meshWainscotWallModel_Temp.updateMatrixWorld();

        const meshWainscotWallModel_CSG = CSG.fromMesh(meshWainscotWallModel_Temp);

        const WainscotWallModel_CSG = meshWainscotWallModel_CSG.subtract(meshDoorDelModel_CSG);
        const WainscotWallModelCSG = WainscotWallModel_CSG.intersect(meshOuterWallDelModel_CSG);
        const WainscotWallModel_CSG_temp1 = WainscotWallModelCSG.subtract(meshDoorDelModelLeft_CSG);
        const WainscotWallModel_CSG_temp2 = WainscotWallModel_CSG_temp1.subtract(meshDoorDelModelRight_CSG);
        const CSGWainscotWallModel = CSG.toMesh(
            WainscotWallModel_CSG_temp2,
            new THREE.Matrix4()
        )

        wainscotModel = CSGWainscotWallModel.geometry;

        return {innerModel, outerModel, wainscotModel}

    }, [params.wallTexture,params.lean_p_pos, params.p_v_w, params.p_w, params.b_l_t_r_p, params.lean_p_w, params.p_r_s, params.lean_p_d, params.lean_p_h, params.add_storage_check, params.add_storage, const_var.newDoorsArray,params.p_b_c_b_l_f, params.p_w_c_n, isPattern, params.leftLeanStoragePosition]);

    const GableStorageLeftWallModelObj = useMemo(() => {
        let outerModel;
        let innerModel;
        let wainscotModel;

        // inner wall model
        const innerWallModel = new THREE.Shape();
        innerWallModel.moveTo(-parseInt(params.add_storage) + 0.005 - frontOffset - sidewallOffset, params.lean_p_h + (params.p_r_s === 1 ? -0.02 : 0));
        innerWallModel.lineTo(sidewallOffset - backOffset, params.lean_p_h + (params.p_r_s === 1 ? -0.02 : 0));
        innerWallModel.lineTo(sidewallOffset - backOffset, (params.p_r_s === 1 ? 0.1 : 0));
        innerWallModel.lineTo(-parseInt(params.add_storage) + 0.005 - frontOffset - sidewallOffset, (params.p_r_s === 1 ? 0.1 : 0));
        innerWallModel.closePath();

        const innerWallCutModel = new THREE.Shape();
        innerWallCutModel.moveTo(-(params.p_w / 2 - sidewallOffset), params.lean_p_h);                           //right lean left top
        innerWallCutModel.lineTo(-(params.p_w / 2 + parseInt(params.add_storage) + frontOffset + sidewallOffset), params.lean_p_h);         //right lean right top
        innerWallCutModel.lineTo(-(params.p_w / 2 + parseInt(params.add_storage) + frontOffset + sidewallOffset), 0);     //right lean right bottom
        innerWallCutModel.lineTo(-(params.p_w / 2 - sidewallOffset), 0);                       //right lean left bottom
        innerWallCutModel.closePath()
        
        const meshInnerWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallModel, extrudeSettings(0.005)));
        const meshDoorDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableLeftLeanLeft', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

        let meshInnerWallModel_Temp = meshInnerWallModel.clone();
        meshInnerWallModel_Temp.position.set(-params.p_w / 2, 0, -params.lean_p_w / 2 - cbFrontBackWallOffset + 0.05);
        meshInnerWallModel_Temp.updateMatrixWorld();
    
        let meshDoorDelModel_Temp = meshDoorDelModel.clone();
        meshDoorDelModel_Temp.position.set(params.leftLeanStoragePosition, 0, -params.lean_p_w / 2 - 0.5);
        meshDoorDelModel_Temp.updateMatrixWorld();

        const meshInnerWallModel_CSG = CSG.fromMesh(meshInnerWallModel_Temp);
        const meshInnerDelModel_CSG = CSG.fromMesh(meshDoorDelModel_Temp);

        const innerWallModel_CSG = meshInnerWallModel_CSG.subtract(meshInnerDelModel_CSG);

        const CSGBackWallModel = CSG.toMesh(
            innerWallModel_CSG,
            new THREE.Matrix4()
        )
    
        innerModel = CSGBackWallModel.geometry;

        // outer wall model
        const verticalHorizontalPos = 
            {
                "x": params.p_w / -2 - frontOffset + sidewallOffset - backOffset + 0.07,
                "y": params.p_w_c_n ? 2.935 : 0,
                "z": params.lean_p_w / -2 - 0.16
            }
        const verticalHorizontalRot = 
            {
                "x": 0,
                "y": Math.PI / -2,
                "z": Math.PI / 2
            }
        const patternLength = params.lean_p_h + (params.p_w_c_n ? -2.935 : 0)
        const patternDepth = parseInt(params.add_storage) + frontOffset + sidewallOffset * 2 - backOffset

        const meshOuterWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLength, isPattern), extrudeSettings(patternDepth)))  
        const meshOuterWallGableDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallCutModel, extrudeSettings(1)))
    
        let meshOuterWallGableDelModel_Temp = meshOuterWallGableDelModel.clone();
        meshOuterWallGableDelModel_Temp.position.set(0,0,params.lean_p_w / -2 - 0.5);
        meshOuterWallGableDelModel_Temp.updateMatrixWorld();
    
        let meshOuterWallModel_Temp = meshOuterWallModel.clone();
        meshOuterWallModel_Temp.position.set(verticalHorizontalPos.x,verticalHorizontalPos.y,verticalHorizontalPos.z);
        meshOuterWallModel_Temp.rotation.set(verticalHorizontalRot.x,verticalHorizontalRot.y,verticalHorizontalRot.z);
        meshOuterWallModel_Temp.updateMatrixWorld();
    
        const mesOuterhWallModel_CSG = CSG.fromMesh(meshOuterWallModel_Temp);
        const meshOuterGableDelModel_CSG = CSG.fromMesh(meshOuterWallGableDelModel_Temp);        
    
        const outerWallModel_CSG = mesOuterhWallModel_CSG.subtract(meshInnerDelModel_CSG);
        const outerWallGableModel_CSG = outerWallModel_CSG.intersect(meshOuterGableDelModel_CSG);

        const CSGOuterWallModel = CSG.toMesh(outerWallGableModel_CSG, new THREE.Matrix4());

        outerModel = CSGOuterWallModel.geometry;

        // wainscot wall model
        const wainscotVerticalHorizontalPos = 
            {
                "x": params.p_w / -2 + sidewallOffset - backOffset,
                "y": 0,
                "z": params.lean_p_w / -2 - 0.16
            }
        const wainscotVerticalHorizontalRot = 
            {
                "x": 0,
                "y": Math.PI / -2,
                "z": Math.PI / 2
            }
        const lengthPattern = 3
        const depthPattern = patternDepth

        const meshWainscotWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPattern, isPattern), extrudeSettings(depthPattern)))
        let meshWainscotWallModel_Temp = meshWainscotWallModel.clone();
        meshWainscotWallModel_Temp.position.set(wainscotVerticalHorizontalPos.x - (0) ,wainscotVerticalHorizontalPos.y,wainscotVerticalHorizontalPos.z);
        meshWainscotWallModel_Temp.rotation.set(wainscotVerticalHorizontalRot.x,wainscotVerticalHorizontalRot.y,wainscotVerticalHorizontalRot.z);
        meshWainscotWallModel_Temp.updateMatrixWorld();

        const meshBackWainscotWallModel_CSG = CSG.fromMesh(meshWainscotWallModel_Temp);

        const wainscotWallModel_CSG = meshBackWainscotWallModel_CSG.subtract(meshInnerDelModel_CSG);

        const CSGBackWainscotModel = CSG.toMesh(
            wainscotWallModel_CSG,
            new THREE.Matrix4()
        )

        wainscotModel = CSGBackWainscotModel.geometry;

        return {innerModel, outerModel, wainscotModel}
    }, [params.wallTexture, params.p_v_w, params.p_h, params.p_w, params.p_r_p, params.add_storage, params.leftLeanStoragePosition, params.lean_p_pos, cbFrontBackWallOffset, params.p_b_c_b_l, params.p_r_s, params.lean_p_w, params.lean_p_d, params.b_l_t_r_p, params.lean_p_h, const_var.newDoorsArray, params.p_w_c_n, frontOffset, isPattern]);

    const GableStorageRightWallModelObj = useMemo(() => {
        let outerModel;
        let innerModel;
        let wainscotModel;

        // inner wall model
        const innerWallModel = new THREE.Shape();
        innerWallModel.moveTo(-parseInt(params.add_storage) + 0.005 - frontOffset - sidewallOffset, params.lean_p_h + (params.p_r_s === 1 ? -0.02 : 0));
        innerWallModel.lineTo(sidewallOffset - backOffset, params.lean_p_h + (params.p_r_s === 1 ? -0.02 : 0));
        innerWallModel.lineTo(sidewallOffset - backOffset, (params.p_r_s === 1 ? 0.1 : 0));
        innerWallModel.lineTo(-parseInt(params.add_storage) + 0.005 - frontOffset - sidewallOffset, (params.p_r_s === 1 ? 0.1 : 0));
        innerWallModel.closePath();

        const innerWallCutModel = new THREE.Shape();

        innerWallCutModel.moveTo(-(params.p_w / 2 - sidewallOffset), params.lean_p_h);                           //right lean left top
        innerWallCutModel.lineTo(-(params.p_w / 2 + parseInt(params.add_storage) + frontOffset + sidewallOffset), params.lean_p_h);         //right lean right top
        innerWallCutModel.lineTo(-(params.p_w / 2 + parseInt(params.add_storage) + frontOffset + sidewallOffset), 0);     //right lean right bottom
        innerWallCutModel.lineTo(-(params.p_w / 2 - sidewallOffset), 0);                       //right lean left bottom
        innerWallCutModel.closePath();

        const meshInnerWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallModel, extrudeSettings(0.005)));
        const meshDoorDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableLeftLeanRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));

        let meshInnerWallModel_Temp = meshInnerWallModel.clone();
        meshInnerWallModel_Temp.position.set(-params.p_w / 2, 0, params.lean_p_w / 2 + cbFrontBackWallOffset - 0.05);
        meshInnerWallModel_Temp.updateMatrixWorld();
    
        let meshDoorDelModel_Temp = meshDoorDelModel.clone();
        meshDoorDelModel_Temp.position.set(params.leftLeanStoragePosition, 0, params.lean_p_w / 2 - 0.5);
        meshDoorDelModel_Temp.updateMatrixWorld();

        const meshInnerWallModel_CSG = CSG.fromMesh(meshInnerWallModel_Temp);
        const meshDoorDelModel_CSG = CSG.fromMesh(meshDoorDelModel_Temp);
    
        const innerWallModel_CSG = meshInnerWallModel_CSG.subtract(meshDoorDelModel_CSG);

        const CSGFrontWallModel = CSG.toMesh(
            innerWallModel_CSG,
            new THREE.Matrix4()
        )
    
        innerModel = CSGFrontWallModel.geometry;

        // outer wall model
        const patternLength = params.lean_p_h + (params.p_w_c_n ? -2.935 : 0)
        const patternDepth = parseInt(params.add_storage) + frontOffset + 2 * sidewallOffset - backOffset
        const verticalHorizontalPos = 
            {
                "x": params.p_w / -2 - sidewallOffset - parseInt(params.add_storage),
                "y": (params.p_w_c_n ? 2.935 : 0),
                "z": params.lean_p_w / 2 + 0.16
            }
        const verticalHorizontalRot = 
            {
                "x": 0,
                "y": Math.PI / 2,
                "z": Math.PI / 2
            }
        const lengthPattern = 3;
        const depthPattern = patternDepth;

        const meshOuterWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLength, isPattern), extrudeSettings(patternDepth)))  
        const meshOuterWallGableDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallCutModel, extrudeSettings(1)))
    
        let meshOuterWallGableDelModel_Temp = meshOuterWallGableDelModel.clone();
        meshOuterWallGableDelModel_Temp.position.set(0,0,params.lean_p_w / 2 - 0.5);
        meshOuterWallGableDelModel_Temp.updateMatrixWorld();
    
        let meshOuterWallModel_Temp = meshOuterWallModel.clone();
        meshOuterWallModel_Temp.position.set(verticalHorizontalPos.x - (frontOffset),verticalHorizontalPos.y,verticalHorizontalPos.z);
        meshOuterWallModel_Temp.rotation.set(verticalHorizontalRot.x,verticalHorizontalRot.y,verticalHorizontalRot.z);
        meshOuterWallModel_Temp.updateMatrixWorld();
    
        const meshOuterWallModel_CSG = CSG.fromMesh(meshOuterWallModel_Temp);
        const meshOuterWallGableDelModel_CSG = CSG.fromMesh(meshOuterWallGableDelModel_Temp);
    
        const outerWallModel_CSG = meshOuterWallModel_CSG.subtract(meshDoorDelModel_CSG);
        const oueterWallGableModel_CSG = outerWallModel_CSG.intersect(meshOuterWallGableDelModel_CSG);

        const CSGWallModel = CSG.toMesh(oueterWallGableModel_CSG,new THREE.Matrix4());

        outerModel = CSGWallModel.geometry;
        
        // wainscot wall model
        const wainscotVerticalHorizontalPos = 
            {
                "x": params.p_w / -2 - sidewallOffset - parseInt(params.add_storage),
                "y": 0,
                "z": params.lean_p_w / 2 + 0.16
            }
        const wainscotVerticalHorizontalRot = 
            {
                "x": 0,
                "y": Math.PI / 2,
                "z": Math.PI / 2
            }
        
        const meshWainscotWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPattern, isPattern), extrudeSettings(depthPattern)))

        let meshWainscotWallModel_Temp = meshWainscotWallModel.clone();
        meshWainscotWallModel_Temp.position.set(wainscotVerticalHorizontalPos.x - (frontOffset),wainscotVerticalHorizontalPos.y,wainscotVerticalHorizontalPos.z);
        meshWainscotWallModel_Temp.rotation.set(wainscotVerticalHorizontalRot.x,wainscotVerticalHorizontalRot.y,wainscotVerticalHorizontalRot.z);
        meshWainscotWallModel_Temp.updateMatrixWorld();

        const meshWainscotWallModel_CSG = CSG.fromMesh(meshWainscotWallModel_Temp);

        const wainscotWallModel_CSG = meshWainscotWallModel_CSG.subtract(meshDoorDelModel_CSG);

        const CSGFrontWainscotModel = CSG.toMesh(
            wainscotWallModel_CSG,
            new THREE.Matrix4()
        )

        wainscotModel = CSGFrontWainscotModel.geometry;

        return {outerModel, innerModel, wainscotModel};

    }, [params.wallTexture,params.p_h, params.p_w, params.p_r_p, params.leftLeanStoragePosition, params.lean_p_pos, params.add_storage, params.p_w, params.lean_p_d, params.p_b_c_b_l_b, params.p_r_s, params.lean_p_w, params.lean_p_h, params.b_l_t_r_p, const_var.newDoorsArray, params.p_w_c_n, params.p_v_w, frontOffset, isPattern]);    

    const texture = useMemo(() => {
        if(const_var.metalTexture){
            let texture = const_var.metalTexture.clone();
            textureAnisotropy(gl, texture,1.3, 1.3, (params.p_v_w != true) ? 0 :  Math.PI/-2);    
            return texture
        }else{
            return null
        }
    }, [params.p_v_w,params.wallTexture,const_var.wallTextureObj[params.wallTexture]])

    const handleMouseEvent = (e) => {
        if (controls.isCheckActiveTab === 'doorwindow' && (const_var.focusedSection === "leftlean" && params.activeWall === "L_L_F_S_W")) {
            switch (e.type) {
                case 'pointerdown':
                case 'click':
                case 'pointermove':
                    e.stopPropagation();
                    break;
                default :
                    break
            }
        }
    };
    const eventHandlers = useMouseEvents(handleMouseEvent);

    return (
        <>
            {params.leftLeanStoragePosition !== params.lean_p_d - parseInt(params.add_storage) && 
                <group name='front_wall' {...eventHandlers}>
                    {GableStorageFrontWallModelObj?.outerModel &&
                        <mesh name="G_L_L_F_S_W_outer" geometry={GableStorageFrontWallModelObj?.outerModel} renderOrder={1}>
                            <MaterialOuterWallNew isPattern={isPattern}   visibleSection={"gableLeftLean"} />
                        </mesh>
                    }
                    {params.p_w_c_n === true && GableStorageFrontWallModelObj?.wainscotModel &&
                        <mesh name="G_L_L_F_S_W_wainscot" geometry={GableStorageFrontWallModelObj?.wainscotModel} position={[-0.005,0,0]} renderOrder={1}>
                            <MaterialWainScotWallNew isPattern={isPattern}   visibleSection={"gableLeftLean"} />
                        </mesh>
                    }
                    {GableStorageFrontWallModelObj && GableStorageFrontWallModelObj?.innerModel && 
                        <mesh name="G_L_L_F_S_W_inner" geometry={GableStorageFrontWallModelObj?.innerModel} position={[wallThickness + 0.01, 0, 0]}>
                            <MaterialInnerWall texture={texture} visibleSection={"gableLeftLean"} />
                        </mesh>
                    }
                </group>
            }
            {params.leftLeanStoragePosition !== 0 && 
                <group name='back_wall'>
                    {GableStorageBackWallModelObj?.outerModel &&
                        <mesh name="G_L_L_B_S_W_outer" geometry={GableStorageBackWallModelObj?.outerModel} renderOrder={1}>
                            <MaterialOuterWallNew isPattern={isPattern} visibleSection={"gableLeftLean"} />
                        </mesh>
                    }
                    {params.p_w_c_n === true && GableStorageBackWallModelObj?.wainscotModel &&
                        <mesh name="G_L_L_B_S_W_wainscot" geometry={GableStorageBackWallModelObj?.wainscotModel} position={[-0.005,0,0]} renderOrder={1}>
                            <MaterialWainScotWallNew isPattern={isPattern}   visibleSection={"gableLeftLean"} />
                        </mesh>
                    }
                    {GableStorageBackWallModelObj && GableStorageBackWallModelObj?.innerModel && 
                        <mesh name="G_L_L_B_S_W_inner" geometry={GableStorageBackWallModelObj?.innerModel} position={[wallThickness + 0.01, 0, 0]}>
                            <MaterialInnerWall texture={texture} visibleSection={"gableLeftLean"} />
                        </mesh>
                    }
                </group>
            }
            
            <group name='right-wall'>
                {GableStorageRightWallModelObj?.outerModel &&
                    <mesh name="G_L_L_R_S_W_outer" geometry={GableStorageRightWallModelObj?.outerModel} renderOrder={1}>
                        <MaterialOuterWallNew isPattern={isPattern}   visibleSection={"gableLeftLean"} />
                    </mesh>
                }
                {params.p_w_c_n === true && GableStorageRightWallModelObj?.wainscotModel &&
                    <mesh name="G_L_L_R_S_W_wainscot" geometry={GableStorageRightWallModelObj?.wainscotModel} position={[0,0,0.005]}renderOrder={1}>
                        <MaterialWainScotWallNew isPattern={isPattern}   visibleSection={"gableLeftLean"} />
                    </mesh>
                }
                {GableStorageRightWallModelObj && GableStorageRightWallModelObj?.innerModel &&
                    <mesh name="G_L_L_R_S_W_inner" geometry={GableStorageRightWallModelObj?.innerModel} position={[0, 0, -wallThickness * 3 - 0.01]}>
                        <MaterialInnerWall texture={texture} visibleSection={"gableLeftLean"} />
                    </mesh>
                }
            </group>
            <group name='left-wall'>
                {GableStorageLeftWallModelObj?.outerModel &&
                    <mesh name="G_L_L_L_S_W_outer" geometry={GableStorageLeftWallModelObj?.outerModel} renderOrder={1}>
                        <MaterialOuterWallNew isPattern={isPattern}   visibleSection={"gableLeftLean"} />
                    </mesh>
                }
                {params.p_w_c_n === true && GableStorageLeftWallModelObj?.wainscotModel &&
                    <mesh name="G_L_L_L_S_W_wainscot" geometry={GableStorageLeftWallModelObj?.wainscotModel} position={[0,0,-0.005]}renderOrder={1}>
                        <MaterialWainScotWallNew isPattern={isPattern}   visibleSection={"gableLeftLean"} />
                    </mesh>
                }
                {GableStorageLeftWallModelObj && GableStorageLeftWallModelObj?.innerModel &&
                    <mesh name="G_L_L_L_S_W_inner" geometry={GableStorageLeftWallModelObj?.innerModel} position={[0, 0, wallThickness + 0.01]}>
                        <MaterialInnerWall texture={texture} visibleSection={"gableLeftLean"} />
                    </mesh>
                }
            </group>
        </>
    )
}

export default WallModel